export default "<ion-router-outlet [animated]=\"false\"></ion-router-outlet>\r\n";